import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJcbLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	"aria-hidden": "true",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 16H5.51786C6.54567 16 7.77679 14.8053 7.77679 13.8667V0H3.25893C2.23112 0 1 1.19467 1 3.2V16Z",
			fill: "#047AB1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.56388 10.816C2.69655 10.8161 1.83349 10.7012 1 10.4746V9.30131C1.64679 9.67902 2.3861 9.89215 3.14598 9.91998C4.01567 9.91998 4.50134 9.34398 4.50134 8.55465V5.33331H6.64732V8.55465C6.64732 9.81331 5.94705 10.816 3.56388 10.816Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.90625 16H13.4241C14.4519 16 15.683 14.8053 15.683 13.8667V0H11.1652C10.1374 0 8.90625 1.19467 8.90625 3.2V16Z",
			fill: "#D42D06"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.90625 6.07999C9.56134 5.48266 10.6908 5.10933 12.5205 5.19466C13.5145 5.23733 14.5536 5.51466 14.5536 5.51466V6.69866C13.9592 6.35918 13.2912 6.15131 12.5996 6.09066C11.2104 5.97333 10.3633 6.70933 10.3633 7.99999C10.3633 9.29066 11.2104 10.0267 12.5996 9.91999C13.2916 9.85393 13.9592 9.64255 14.5536 9.30133V10.4747C14.5536 10.4747 13.5145 10.7627 12.5205 10.8053C10.6908 10.8907 9.56134 10.5173 8.90625 9.91999V6.07999Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8125 16H21.3304C22.3582 16 23.5893 14.8053 23.5893 13.8667V0H19.0714C18.0436 0 16.8125 1.19467 16.8125 3.2V16Z",
			fill: "#67B637"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4598 9.27998C22.4598 10.1333 21.7596 10.6666 20.8221 10.6666H16.8125V5.33331H20.4607L20.7204 5.34398C21.545 5.38665 22.1549 5.84531 22.1549 6.63465C22.1549 7.25331 21.737 7.78665 20.9802 7.91465V7.94665C21.816 7.99998 22.4598 8.50131 22.4598 9.27998ZM19.5797 6.17598C19.5311 6.16911 19.482 6.16555 19.4329 6.16531H18.0775V7.50931H19.5797C19.8621 7.44531 20.0992 7.19998 20.0992 6.83731C20.0992 6.47465 19.8621 6.22931 19.5797 6.17598ZM19.7491 8.35198C19.6894 8.34312 19.6289 8.33955 19.5684 8.34131H18.0775V9.80265H19.5684L19.7491 9.78131C20.0315 9.71731 20.2687 9.43998 20.2687 9.06665C20.2687 8.69331 20.0428 8.42665 19.7491 8.35198Z",
			fill: "white"
		})
	]
});
export default SvgJcbLogo;
